import { getAuthRoute as getAuthRouteFromFeatures } from 'features';

import { ROUTE } from '../config';

export const getAuthRoute = (path: string) => {
  return getAuthRouteFromFeatures(ROUTE, path);
};
